import HourHero from 'assets/images/psp/PSPHero/24-hour-hero.webp';
import Featured1 from 'assets/images/psp/FeaturedContentImages/heroFeatured1.jpg';
import Featured2 from 'assets/images/psp/FeaturedContentImages/heroFeatured2.webp';
import Featured3 from 'assets/images/psp/FeaturedContentImages/heroFeatured3.png';
import Featured4 from 'assets/images/psp/FeaturedContentImages/heroFeatured4.jpg';
import Charttwo1 from 'assets/images/psp/24-HourIcons/24-SizeChartTwo/iconOne.svg';
import Charttwo2 from 'assets/images/psp/24-HourIcons/24-SizeChartTwo/iconTwo.svg';
import Charttwo3 from 'assets/images/psp/24-HourIcons/24-SizeChartTwo/iconThree.svg';
import Charttwo4 from 'assets/images/psp/24-HourIcons/24-SizeChartTwo/iconFour.svg';
import Charttwo5 from 'assets/images/psp/24-HourIcons/24-SizeChartTwo/iconFive.svg';
import Charttwo6 from 'assets/images/psp/24-HourIcons/24-SizeChartTwo/iconSix.svg';
import ChartOne1 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconOne.svg';
import ChartOne2 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconTwo.svg';
import ChartOne3 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconThree.svg';
import ChartOne4 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconFour.svg';
import ChartOne5 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconFive.svg';
import ChartOne6 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconSix.svg';
import ChartOne7 from 'assets/images/psp/24-HourIcons/24-SizeChartOne/iconSeven.svg';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const reviews = [
	{
		title: 'SpareFoot helped me secure a storage unit and…',
		stars: 5,
		text: 'SpareFoot helped me secure a storage unit and make a reservation with little personal information. I was able to see and compare many storage locations, storage type, price and size online before deciding.I was contacted right away by a real person who was very friendly and informative. The personal service is very important.',
		customerName: 'Alice',
		date: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68d78fcd296d476c63e494c0',
	},
	{
		title: 'Made picking a storage facility quick and easy',
		stars: 5,
		text: 'SpareFoot made it very easy to choose and reserve the storage facility that I wanted. Received quick notification from the storage facility about my reservation. Everything went smoothly.',

		customerName: 'Dawn',
		date: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68d373416f678003b1f8cfb9',
	},
	{
		title: 'Quick and easy',
		stars: 5,
		text: 'I was able to reserve what I needed online with SpareFoot, and the phone contact was well within 24 hours and very personable. Decent price compared to other storage places in the area. Convenient, quiet, and easy to get to. Highly recommend.',
		customerName: 'Barbara',
		date: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68d054bd80f72e95a81079be',
	},
	{
		title: 'I have used SpareFoot in the past and…',
		stars: 5,
		text: 'I have used Spare Foot in the past and was very pleased with their service. Recently, I had minutes to find a storage unit so I got in touch with them and they had me set up in the nick of time. Spare Foot will always be my go to for storage needs.',
		customerName: 'John',
		date: 'January 3rd, 2023',
		link: 'https://www.trustpilot.com/reviews/68c2e914b6a28af5a755844a',
	},
];
const faqs = [
	{
		question:
			'Is 24 hour access storage more expensive than regular storage?',
		answer: 'Not always! Many modern facilities include 24-hour access as a standard feature at no extra cost. Some facilities charge an additional $10-20 per month for this convenience, but the flexibility is often worth it for busy schedules.',
	},
	{
		question: 'How does 24-hour access work at storage facilities?',
		answer: 'You receive a personalized gate code or key card that grants entry anytime. Most 24-hour access storage units have automated gates, security cameras, and well-lit driveways so you can safely access your unit even at 2 AM.',
	},
	{
		question: 'Are 24/7 storage facilities safe to visit at night?',
		answer: "Yes, reputable storage units invest heavily in security including video surveillance, motion-sensor lighting, individual unit alarms, and often 24-hour monitoring. The busiest access times are often early mornings and late evenings, so you won't be alone.",
	},
	{
		question: 'Can anyone access the facility, or just me?',
		answer: 'Only tenants with valid gate codes or access cards can enter. You control who you share your code with, and most facilities let you authorize additional users on your account for family members or business partners.',
	},
	{
		question: 'Do all storage facilities offer 24-hour access?',
		answer: "No, smaller or older facilities may have office hours-only access (typically 6 AM-9 PM). When searching for the cheapest storage with 24 hour access near me, confirm this feature before renting—it's not universal but increasingly common.",
	},
	{
		question: 'What if I lose my gate code or access card?',
		answer: 'Contact the facility office during business hours to reset your code or issue a new card. Most facilities charge a small replacement fee ($5-20) for lost cards but can reset digital codes for free.',
	},
	{
		question: 'Can I access my storage unit 24/7 during the first month?',
		answer: 'Most facilities grant immediate 24-hour access storage privileges as soon as you complete your rental agreement and payment. Some may require a brief orientation or identity verification before activating your gate code.',
	},
];
export const TwentyFourHourContent = {
	type: '24 Hour',
	reviews: reviews,
	sections: [
		{
			title: '24-Hour-Storage',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: '24-Hour-storage-hero',
					props: {
						content: {
							title: 'Find Affordable 24 Hour Self Storage',
							description:
								"Life doesn't stop after your 9-5, and neither should access to your belongings.\n\n With 24-hour access storage, you can retrieve items, drop off inventory, or check on your unit whenever your schedule demands—no waiting for office hours or weekend restrictions. With secure gate codes and well-lit facilities, you can have access to your storage unit 24/7/365. \n\nFinding the cheapest storage with 24 hour access doesn’t mean sacrificing quality or accessibility. Come find your perfect self storage unit with **SelfStorage.com**.",
							image: HourHero,
							CTAtext: 'Find 24 Hour Self Storage',
							storageType: '24-Hour',
						},
					},
				},
			],
		},
		{
			title: 'Size Chart 1',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading:
							'Who Benefits from 24 Hour Access Self Storage?',
						cardData: [
							{
								title: 'Busy Families',
								content:
									'Work, kids, maintaining your partnership…these things don’t go away when the sun goes down. 24-hour access storage means you can access your seasonal items, hidden Christmas presents, and other valuables anytime. Early risers and night owls alike win with all-day access.',
								imageSrc: ChartOne1,
								contentAlign: 'text-left',
							},
							{
								title: 'Small Business Owners & Entrepreneurs',
								content:
									"Need to restock merchandise at 11 PM or prep for an early morning farmers market? [Storage units with 24-hour access serve as mini-warehouses](https://www.selfstorage.com/blog/business-and-commercial-storage-units-2/) for inventory, supplies, and equipment accessible on your business schedule, not a facility's office hours.",
								imageSrc: ChartOne2,
								contentAlign: 'text-left',
							},
							{
								title: 'Healthcare Workers & Shift Employees',
								content:
									'Nurses, first responders, and night shift workers often need access at unconventional hours. With 24-hour access storage units, you can swing by after a 12-hour shift without rushing to beat closing time.',
								imageSrc: ChartOne3,
								contentAlign: 'text-left',
							},
							{
								title: 'Contractors & Tradespeople',
								content:
									'When a job starts at 6 AM or a client emergency happens at 8 PM, contractors need immediate access to tools and materials. Storage units open 24/7 function as on-demand equipment hubs for busy professionals.',
								imageSrc: ChartOne4,
								contentAlign: 'text-left',
							},
							{
								title: 'College Students & Young Professionals',
								content:
									'Moving apartments on a Sunday morning? Need to grab that lamp at 10 PM for your new place? Storage with 24-hour access eliminates the stress of coordinating move-out times with storage facility hours.',
								imageSrc: ChartOne5,
								contentAlign: 'text-left',
							},
							{
								title: 'Online Sellers & Resellers',
								content:
									'eBay and Etsy sellers who photograph and ship items on evenings and weekends benefit from storage units 24 hr access to organize inventory and prep shipments whenever orders come in.',
								imageSrc: ChartOne6,
								contentAlign: 'text-left',
							},
							{
								title: 'Hobbyists & Collectors',
								content:
									"Whether you're restoring a car, building furniture, or managing a trading card collection, [24-hour access storage means you can work on projects when inspiration](https://www.selfstorage.com/blog/hobby-organization/) strikes—not when a gate opens.",
								imageSrc: ChartOne7,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Size Chart 2',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Storage Unit Sizes & 24-Hour Access Pricing',
						description:
							'You’re looking for the cheapest storage with 24-hour access without sacrificing security or quality. The good news is that you can shop, compare, and reserve affordable self storage units that fit your schedule with **SelfStorage.com**.\n\nHere’s what you can expect to pay for common unit sizes and 24-hour access, [based on our networks average pricing data](https://www.selfstorage.com/blog/storage-unit-prices/).',
						cardData: [
							{
								title: '5x5',
								content:
									'**Best for**: Business inventory boxes, seasonal items, and personal storage, holiday present stashes \n\n **Average monthly cost with 24-hour access**: $55 - $85',
								imageSrc: Charttwo1,
								averageMonthlyCost: '$55 - $85',
								contentAlign: 'text-left',
							},
							{
								title: '5x10',
								content:
									'**Best for**: Small business stock, tools, equipment, apartment contents \n\n **Average monthly cost with 24-hour access**: $85 - $125',
								imageSrc: Charttwo2,
								averageMonthlyCost: ' $85 - $125',
								contentAlign: 'text-left',
							},
							{
								title: '10x10',
								content:
									'**Best for**: Large inventory, contractor tools, 1-2 bedroom apartment \n\n **Average monthly cost with 24-hour access**: $110 - $185',
								imageSrc: Charttwo3,
								averageMonthlyCost: '$110 - $185',
								contentAlign: 'text-left',
							},
							{
								title: '10x15',
								content:
									"**Best for**: Retail inventory, multiple vendors' stock, 2-bedroom home \n\n **Average monthly cost with 24-hour access**: $150 - $235",
								imageSrc: Charttwo4,
								averageMonthlyCost: '$150 - $235',
								contentAlign: 'text-left',
							},
							{
								title: '10x20',
								content:
									'**Best for**: Wholesale inventory, equipment fleet, 3-bedroom home \n\n **Average monthly cost with 24-hour access**: $180 - $290',
								imageSrc: Charttwo5,
								averageMonthlyCost: ' $180 - $290',
								contentAlign: 'text-left',
							},
							{
								title: '10x30',
								content:
									'**Best for**: Large business warehouse needs, vehicle + inventory storage \n\n **Average monthly cost with 24-hour access**: $255 - $385',
								imageSrc: Charttwo6,
								averageMonthlyCost: '$255 - $385',
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							reviews,
							headerTitle: '24-Hour Access Self Storage: ',
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: '24-Hour Access Self Storage FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading:
								'Learn All About 24-Hour Access Self Storage',
							data: {
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/24-hour-storage-amenities/',
										date: 'April 15, 2025',
										image: Featured1,
										content:
											'24/7 Storage: What Amenities are Worth Your Time and Money?',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/',
										date: 'November 4, 2025',
										image: Featured2,
										content:
											'Why Would You Need a Climate-Controlled Storage Unit?',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/cheapest-storage-unit-prices/',
										date: 'September 16, 2025',
										image: Featured3,
										content:
											'What is the Cheapest Storage Unit You Can Rent?',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/long-term-vs-short-term-storage-guide/',
										date: 'September 9, 2025',
										image: Featured4,
										content:
											'Long Term Self Storage vs. Short Term Storage: What’s Best for You?',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						linksList: storageCategories.access24Hour,
					},
				},
			],
		},

		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: '24 Hour',
					},
				},
			],
		},
	],
};
